import { Box, Modal, Typography } from "@mui/material";
import React from "react";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: 4,
};

export enum MODALTYPE {
  OK = 'ok',
  CONFIRM = 'confirm',
  DELETE = 'delete',
  LOG = 'logOut'
};

interface ModalAlertProps {
  modalData: ModalData;
  onClose: () => void;
}

interface ActionButtonProps {
  label: string;
  onClick: () => void;
  variant: 'secondary' | 'danger';
}

export type ModalData = {
  show: boolean;
  title?: string;
  message?: string;
  type?: MODALTYPE;
  action?: () => void;
};

export const modalDataClean = {
  show: false,
};

export const ModalAlert = ({ modalData, onClose }: ModalAlertProps) => {

  const handleAction = () => {
    modalData.action?.();
    onClose();
  };

  const ActionButton = ({ label, onClick, variant }: ActionButtonProps) => (
    <div className="col d-grid gap-2">
      <button onClick={onClick} className={`btn btn-${variant}`}>
        {label}
      </button>
    </div>
  );

  const renderButtons = () => {
    switch (modalData.type) {
      case MODALTYPE.DELETE:
        return (
          <>
            <ActionButton label="Annulla" onClick={onClose} variant="secondary" />
            <ActionButton label="Elimina" onClick={handleAction} variant="danger" />
          </>
        );
      case MODALTYPE.LOG:
        return (
          <>
            <ActionButton label="Annulla" onClick={onClose} variant="secondary" />
            <ActionButton label="Esci" onClick={handleAction} variant="danger" />
          </>
        );
      case MODALTYPE.OK:
        return (
          <>
            <div className="col d-grid gap-2" />
            <ActionButton label="OK" onClick={onClose} variant="secondary" />
          </>
        );
      case MODALTYPE.CONFIRM:
        return (
          <>
            <ActionButton label="Annulla" onClick={onClose} variant="secondary" />
            <ActionButton label="OK" onClick={handleAction} variant="danger" />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Modal open={modalData.show} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {modalData.title}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {modalData.message}
        </Typography>
        <div className="row text-center">
          {renderButtons()}
        </div>
      </Box>
    </Modal>
  );
};


